__turbopack_context__.v({
  "align-center": "Footer-module-scss-module__a9fGWq__align-center",
  "align-justify": "Footer-module-scss-module__a9fGWq__align-justify",
  "align-left": "Footer-module-scss-module__a9fGWq__align-left",
  "align-right": "Footer-module-scss-module__a9fGWq__align-right",
  "bold": "Footer-module-scss-module__a9fGWq__bold",
  "brand-text-container": "Footer-module-scss-module__a9fGWq__brand-text-container",
  "contact": "Footer-module-scss-module__a9fGWq__contact",
  "contact-headline": "Footer-module-scss-module__a9fGWq__contact-headline",
  "contact-link": "Footer-module-scss-module__a9fGWq__contact-link",
  "contact-opening-hours": "Footer-module-scss-module__a9fGWq__contact-opening-hours",
  "copyright": "Footer-module-scss-module__a9fGWq__copyright",
  "footer": "Footer-module-scss-module__a9fGWq__footer",
  "footer-section": "Footer-module-scss-module__a9fGWq__footer-section",
  "footer-section-secondary": "Footer-module-scss-module__a9fGWq__footer-section-secondary",
  "footer-top": "Footer-module-scss-module__a9fGWq__footer-top",
  "home-link": "Footer-module-scss-module__a9fGWq__home-link",
  "italic": "Footer-module-scss-module__a9fGWq__italic",
  "logo": "Footer-module-scss-module__a9fGWq__logo",
  "mapper-a": "Footer-module-scss-module__a9fGWq__mapper-a",
  "mapper-p": "Footer-module-scss-module__a9fGWq__mapper-p",
  "menu": "Footer-module-scss-module__a9fGWq__menu",
  "menu-secondary": "Footer-module-scss-module__a9fGWq__menu-secondary",
  "placeholder": "Footer-module-scss-module__a9fGWq__placeholder",
  "primary-nav": "Footer-module-scss-module__a9fGWq__primary-nav",
  "primary-nav-headline": "Footer-module-scss-module__a9fGWq__primary-nav-headline",
  "primary-nav-item": "Footer-module-scss-module__a9fGWq__primary-nav-item",
  "primary-nav-menu": "Footer-module-scss-module__a9fGWq__primary-nav-menu",
  "secondary-nav": "Footer-module-scss-module__a9fGWq__secondary-nav",
  "secondary-nav-home-link": "Footer-module-scss-module__a9fGWq__secondary-nav-home-link",
  "size-l": "Footer-module-scss-module__a9fGWq__size-l",
  "size-m": "Footer-module-scss-module__a9fGWq__size-m",
  "size-s": "Footer-module-scss-module__a9fGWq__size-s",
  "size-xs": "Footer-module-scss-module__a9fGWq__size-xs",
  "spacing": "Footer-module-scss-module__a9fGWq__spacing",
  "teaser": "Footer-module-scss-module__a9fGWq__teaser",
  "text": "Footer-module-scss-module__a9fGWq__text",
});
